/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_P_Li4Inputs */

const tr_mesafeli_s8_p_li4 = /** @type {(inputs: Mesafeli_S8_P_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri İçeriği'ne ilişkin veri ihlali tespit edildiğinde KVKK Madde 12/5 uyarınca 72 saat içinde Müşteri'ye ve Kişisel Verileri Koruma Kurulu'na bildirimde bulunmak.`)
};

const en_mesafeli_s8_p_li4 = /** @type {(inputs: Mesafeli_S8_P_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where a data breach concerning Customer Content is detected, to notify the Customer and the Kişisel Verileri Koruma Kurulu (Personal Data Protection Board) within 72 hours pursuant to KVKK Article 12/5.`)
};

const de_mesafeli_s8_p_li4 = /** @type {(inputs: Mesafeli_S8_P_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Feststellung einer Datenschutzverletzung in Bezug auf Kundeninhalte gemäß KVKK Artikel 12/5 innerhalb von 72 Stunden den Kunden und das Kişisel Verileri Koruma Kurulu (Ausschuss zum Schutz personenbezogener Daten) benachrichtigen.`)
};

const ru_mesafeli_s8_p_li4 = /** @type {(inputs: Mesafeli_S8_P_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При выявлении нарушения безопасности данных, касающегося Контента Клиента, уведомить Клиента и Kişisel Verileri Koruma Kurulu (Совет по защите персональных данных) в течение 72 часов согласно статье 12/5 KVKK.`)
};

/**
* | output |
* | --- |
* | "Where a data breach concerning Customer Content is detected, to notify the Customer and the Kişisel Verileri Koruma Kurulu (Personal Data Protection Board) w..." |
*
* @param {Mesafeli_S8_P_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_p_li4 = /** @type {((inputs?: Mesafeli_S8_P_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_P_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_p_li4(inputs)
	if (locale === "de") return de_mesafeli_s8_p_li4(inputs)
	if (locale === "ru") return ru_mesafeli_s8_p_li4(inputs)
	return tr_mesafeli_s8_p_li4(inputs)
});